var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"card-icon text-gray-600",style:(_vm.cssStyle),attrs:{"href":_vm.href}},[_vm._t("icon"),_c('p',{staticClass:"text-center m-0"},[_vm._t("label")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }